(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7596],{

/***/ 10918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ FiltersForm; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./client/components/FiltersContainer/context.tsx
var context = __webpack_require__(16190);
// EXTERNAL MODULE: ./src/comps/Checkbox/index.js
var Checkbox = __webpack_require__(61706);
// EXTERNAL MODULE: ./client/components/FilterAccommodationTypes/constants.ts
var constants = __webpack_require__(84884);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(12411);
// EXTERNAL MODULE: ./client/styles/index.js + 4 modules
var styles = __webpack_require__(89804);
;// CONCATENATED MODULE: ./client/components/FilterAccommodationTypes/styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-block: 15px;\n  padding-inline: 20px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: 700;\n  margin-block-end: 1rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  > li {\n    margin-block: 0 5px;\n    margin-inline: 0;\n    font-size: 16px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var FilterAccommodationTypesBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__FilterAccommodationTypesBase",
    componentId: "sc-70905d6a-0"
})(_templateObject());
var Title = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "styles__Title",
    componentId: "sc-70905d6a-1"
})(_templateObject1(), styles/* colors.grey1 */.O9.grey1);
var List = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "styles__List",
    componentId: "sc-70905d6a-2"
})(_templateObject2());

// EXTERNAL MODULE: ../../packages/react-context/src/index.tsx + 11 modules
var src = __webpack_require__(67048);
;// CONCATENATED MODULE: ./client/components/FilterAccommodationTypes/index.tsx










var FilterAccommodationTypes = function() {
    var handleClick = function handleClick(accommodation) {
        var index = selected.indexOf(accommodation);
        var accommodationExists = index > -1;
        var filteredAccommodations = accommodationExists ? selected.filter(function(f, i) {
            return i !== index;
        }) : (0,_to_consumable_array/* default */.Z)(selected).concat([
            accommodation
        ]);
        setFilters((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters), {
            accommodationTypes: filteredAccommodations
        }));
    };
    var i18n = (0,src/* useS4LContext */.ms)().i18n;
    var ref = (0,react.useContext)(context/* FiltersContext */.o), filters = ref.filters, setFilters = ref.setFilters;
    var ref1 = (0,react.useState)([]), selected = ref1[0], setSelected = ref1[1];
    (0,react.useEffect)(function() {
        setSelected(filters.accommodationTypes || []);
    }, [
        filters.accommodationTypes
    ]);
    var keys = {
        hotel: i18n.formatMessage({
            id: "global.hotel"
        }),
        apartment: i18n.formatMessage({
            id: "global.apartment"
        }),
        villa: i18n.formatMessage({
            id: "global.villa"
        }),
        homes: i18n.formatMessage({
            id: "global.homes"
        }),
        hostel: i18n.formatMessage({
            id: "global.hostel"
        }),
        resort: i18n.formatMessage({
            id: "global.resort"
        }),
        apthotel: i18n.formatMessage({
            id: "global.apthotel"
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterAccommodationTypesBase, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: i18n.formatMessage({
                    id: "global.accommodation"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                children: constants/* ACCOMMODATION_TYPES.map */.e.map(function(accommodation) {
                    var name = accommodation.name, slug = accommodation.slug;
                    var isSelected = !!selected.find(function(f) {
                        return f === slug;
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            label: keys[name],
                            name: "accommodation-".concat(slug),
                            onChange: function() {
                                return handleClick(slug);
                            },
                            selected: isSelected
                        })
                    }, "accommodation-".concat(slug));
                })
            })
        ]
    });
};
/* harmony default export */ var components_FilterAccommodationTypes = (FilterAccommodationTypes);

// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(42670);
// EXTERNAL MODULE: ./client/icons/Star.js
var Star = __webpack_require__(83082);
;// CONCATENATED MODULE: ./client/components/FilterCategory/styles.js

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-block: 15px;\n  padding-inline: 20px;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: 700;\n  margin-block-end: 1em;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  > li {\n    margin-inline-end: 0.25em;\n    svg.star-icon {\n      margin-block: 0;\n      margin-inline: 4px 0;\n    }\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var FilterCategoryBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__FilterCategoryBase",
    componentId: "sc-ff5c96e6-0"
})(styles_templateObject());
var styles_Title = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "styles__Title",
    componentId: "sc-ff5c96e6-1"
})(styles_templateObject1(), styles/* colors.grey1 */.O9.grey1);
var styles_List = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "styles__List",
    componentId: "sc-ff5c96e6-2"
})(styles_templateObject2());

// EXTERNAL MODULE: ../../node_modules/react-intl/lib/index.js + 1 modules
var lib = __webpack_require__(49177);
;// CONCATENATED MODULE: ./client/components/FilterCategory/messages.js

var messages = (0,lib/* defineMessages */.vU)({
    category: {
        id: "global.category"
    }
});
/* harmony default export */ var FilterCategory_messages = (messages);

;// CONCATENATED MODULE: ./client/components/FilterCategory/index.js












var availableCategories = [
    "5",
    "4",
    "3",
    "2",
    "1"
];
var hideCategories = [
    "1"
];
var FilterCategory = function() {
    var handleClick = function handleClick(category) {
        var index = selected.indexOf(category);
        var isActive = index > -1;
        var selectedCategories = isActive ? selected.filter(function(c, i) {
            return i !== index;
        }).sort() : (0,_to_consumable_array/* default */.Z)(selected).concat([
            category
        ]).sort();
        if (selectedCategories.filter(function(c) {
            return !hideCategories.includes(c);
        }).length > 0) {
            setFilters((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters), {
                stars: selectedCategories
            }));
            return;
        }
        setFilters((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters), {
            stars: []
        }));
    };
    var buildStars = function buildStars(category) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: Array(Number(category)).fill().map(function(_, i) {
                return /* eslint-disable-next-line react/no-array-index-key */ /*#__PURE__*/ (0,jsx_runtime.jsx)(Star/* default */.Z, {
                    size: 14,
                    fill: styles/* colors.grey2 */.O9.grey2,
                    className: "star-icon"
                }, i);
            })
        });
    };
    var ref = (0,react.useContext)(context/* FiltersContext */.o), filters = ref.filters, setFilters = ref.setFilters;
    var ref1 = (0,react.useState)([]), selected = ref1[0], setSelected = ref1[1];
    (0,react.useEffect)(function() {
        setSelected(filters.stars || []);
    }, [
        filters.stars
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterCategoryBase, {
        "data-testid": "filter-category",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Title, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, FilterCategory_messages.category))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_List, {
                children: availableCategories.filter(function(c) {
                    return !hideCategories.includes(c);
                }).map(function(category) {
                    var isSelected = selected.includes(category);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            label: buildStars(category),
                            name: "star-".concat(category),
                            onChange: function() {
                                return handleClick(category);
                            },
                            selected: isSelected
                        })
                    }, "star-".concat(category));
                })
            })
        ]
    });
};
/* harmony default export */ var components_FilterCategory = (FilterCategory);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(83112);
// EXTERNAL MODULE: ./client/components/FilterFacilities/constants.js
var FilterFacilities_constants = __webpack_require__(9907);
// EXTERNAL MODULE: ./client/icons/facilities/Facility.js
var Facility = __webpack_require__(60393);
;// CONCATENATED MODULE: ./client/components/FilterFacilities/styles.js

function FilterFacilities_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-block: 15px;\n  padding-inline: 20px;\n"
    ]);
    FilterFacilities_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FilterFacilities_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: 700;\n  margin-block-end: 1rem;\n"
    ]);
    FilterFacilities_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FilterFacilities_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-block: 0;\n  padding-inline: 0;\n  list-style-type: none;\n  display: flex;\n  flex-wrap: wrap;\n"
    ]);
    FilterFacilities_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-block: 0.25rem;\n  margin-inline: 0.25rem;\n  max-width: 100%;\n\n  &:last-of-type {\n    /* fixes flexbox flow (see comments https://bitbucket.org/stay4longdev/web-stayforlong/pull-requests/1301/stay-4467-fixes-broken-facilities-layout/diff?w=1) */\n    max-width: 97%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border: 2px solid ",
        ";\n  border-radius: 60px;\n  color: ",
        ";\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  font-family: ",
        ";\n  padding-block: 6px;\n  padding-inline: 15px;\n  width: auto;\n  white-space: nowrap;\n  justify-content: center;\n  font-size: 14px;\n\n  &:focus {\n    outline: none;\n  }\n\n  svg {\n    fill: ",
        ";\n    margin-inline-end: 10px;\n    width: 18px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* Styles to hide checkbox */\n  border: 0;\n  clip-path: inset(50%);\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin-block: -1px;\n  margin-inline: -1px;\n  overflow: hidden;\n  padding-block: 0;\n  padding-inline: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  inset-block-start: 0;\n  inset-inline-start: 0;\n  background-color: ",
        ";\n  width: 100%;\n  height: 100%;\n  z-index: var(--z-behind);\n\n  ",
        ":checked + & {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var FilterFacilitiesBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__FilterFacilitiesBase",
    componentId: "sc-8788a728-0"
})(FilterFacilities_styles_templateObject());
var FilterFacilities_styles_Title = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "styles__Title",
    componentId: "sc-8788a728-1"
})(FilterFacilities_styles_templateObject1(), styles/* colors.grey1 */.O9.grey1);
var FilterFacilities_styles_List = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "styles__List",
    componentId: "sc-8788a728-2"
})(FilterFacilities_styles_templateObject2());
var Item = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "styles__Item",
    componentId: "sc-8788a728-3"
})(_templateObject3());
var Label = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
    displayName: "styles__Label",
    componentId: "sc-8788a728-4"
})(_templateObject4(), function(props) {
    return props.selected ? styles/* colors.magenta2 */.O9.magenta2 : styles/* colors.white */.O9.white;
}, function(props) {
    return props.selected ? styles/* colors.magenta */.O9.magenta : styles/* colors.grey4 */.O9.grey4;
}, function(props) {
    return props.selected ? styles/* colors.magenta */.O9.magenta : styles/* colors.grey2 */.O9.grey2;
}, styles/* fonts.default */.Rq["default"], function(props) {
    return props.selected ? styles/* colors.magenta */.O9.magenta : styles/* colors.grey2 */.O9.grey2;
});
var FacilityText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__FacilityText",
    componentId: "sc-8788a728-5"
})(_templateObject5());
var styles_Checkbox = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    displayName: "styles__Checkbox",
    componentId: "sc-8788a728-6"
})(_templateObject6());
var Pill = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    displayName: "styles__Pill",
    componentId: "sc-8788a728-7"
})(_templateObject7(), styles/* colors.blue */.O9.blue, styles_Checkbox, styles/* colors.grey1 */.O9.grey1);

// EXTERNAL MODULE: ./client/messages.js
var client_messages = __webpack_require__(1786);
;// CONCATENATED MODULE: ./client/components/FilterFacilities/messages.js

var messages_messages = (0,lib/* defineMessages */.vU)({
    facilities: {
        id: "global.facilities"
    },
    wifi: {
        id: "global.wifi"
    },
    carpark: {
        id: "global.car-park"
    },
    gym: {
        id: "global.gym"
    },
    outdoorpool: {
        id: "global.outdoor-pool"
    },
    indoorpool: {
        id: "global.indoor-pool"
    },
    spa: {
        id: "global.spa"
    },
    restaurant: {
        id: "global.restaurant"
    },
    wheelchair: {
        id: "global.wheelchair"
    },
    airportshuttle: {
        id: "global.airport-shuttle"
    },
    safebox: {
        id: "global.safebox"
    }
});
/* harmony default export */ var FilterFacilities_messages = (messages_messages);

;// CONCATENATED MODULE: ./client/components/FilterFacilities/index.js













var FilterFacilities = function() {
    var translate = function translate(copy, values) {
        return FilterFacilities_messages[copy] && (0,_define_property/* default */.Z)({}, copy, intl.formatMessage(FilterFacilities_messages[copy], values));
    };
    var handleClick = function handleClick(event) {
        var facility = event.target.name;
        var index = selected.indexOf(facility);
        var facilityExists = index > -1;
        var filteredFacilities = facilityExists ? selected.filter(function(f, i) {
            return i !== index;
        }) : (0,_to_consumable_array/* default */.Z)(selected).concat([
            facility
        ]);
        setFilters((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters), {
            facilities: filteredFacilities
        }));
    };
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useContext)(context/* FiltersContext */.o), filters = ref.filters, setFilters = ref.setFilters;
    var ref1 = (0,react.useState)([]), selected = ref1[0], setSelected = ref1[1];
    (0,react.useEffect)(function() {
        setSelected(filters.facilities || []);
    }, [
        filters.facilities
    ]);
    var facilitiesMessages = (0,_object_spread/* default */.Z)({}, translate("airportshuttle"), translate("carpark"), translate("facilities"), translate("gym"), translate("indoorpool"), translate("outdoorpool"), translate("restaurant"), translate("safebox"), translate("spa"), translate("wheelchair"), translate("wifi"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterFacilitiesBase, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterFacilities_styles_Title, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, (0,_object_spread/* default */.Z)({}, client_messages/* default.facilities */.Z.facilities))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterFacilities_styles_List, {
                children: FilterFacilities_constants/* FACILITIES.map */.u.map(function(facility) {
                    var id = facility.id, name = facility.name, icon = facility.icon, slug = facility.slug;
                    var formattedName = name.toLowerCase();
                    var isSelected = !!selected.find(function(f) {
                        return f === slug;
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Label, {
                            htmlFor: "facility-".concat(slug),
                            selected: isSelected,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Facility/* default */.Z, {
                                    name: icon
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Checkbox, {
                                    id: "facility-".concat(slug),
                                    name: slug,
                                    onChange: handleClick,
                                    type: "checkbox"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FacilityText, {
                                    children: facilitiesMessages[formattedName]
                                })
                            ]
                        })
                    }, id);
                })
            })
        ]
    });
};
/* harmony default export */ var components_FilterFacilities = (FilterFacilities);

// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(94449);
// EXTERNAL MODULE: ../../packages/stayforlong/src/_kernel/PriceType.ts
var PriceType = __webpack_require__(4962);
// EXTERNAL MODULE: ./src/effects/Properties/selectors.js
var selectors = __webpack_require__(82598);
// EXTERNAL MODULE: ./src/hooks/useMarket.ts
var useMarket = __webpack_require__(59806);
// EXTERNAL MODULE: ./src/hooks/usePrices/index.ts
var usePrices = __webpack_require__(83310);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../node_modules/rc-slider/es/index.js + 35 modules
var rc_slider_es = __webpack_require__(90843);
// EXTERNAL MODULE: ../../node_modules/rc-slider/assets/index.css
var assets = __webpack_require__(79373);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../packages/utils/src/library/rtl.ts
var rtl = __webpack_require__(75570);
// EXTERNAL MODULE: ./client/components/InputLine/styles.js
var InputLine_styles = __webpack_require__(52342);
;// CONCATENATED MODULE: ./client/components/PriceRangeHistogram/styles.js

function PriceRangeHistogram_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-block: 27px 30px;\n  margin-inline: 10px;\n  ",
        "\n  .rc-slider-rail {\n    height: 2px;\n    background-color: ",
        ";\n  }\n  .rc-slider-track {\n    background-color: ",
        ";\n    height: 2px;\n  }\n  .rc-slider-handle {\n    width: 24px;\n    height: 24px;\n    border: solid 2px ",
        ";\n    margin-block-start: -11px;\n  }\n  .rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {\n    border-color: ",
        ";\n    box-shadow: 0 0 0 5px ",
        ";\n  }\n"
    ]);
    PriceRangeHistogram_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PriceRangeHistogram_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  margin-block-end: 10px;\n  ",
        "\n  ",
        " {\n    max-width: calc(50% - 12px);\n  }\n"
    ]);
    PriceRangeHistogram_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PriceRangeHistogram_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: flex-end;\n  margin-block-end: -5px;\n"
    ]);
    PriceRangeHistogram_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: ",
        "px;\n  margin-block-end: -5px;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  width: 100%;\n  height: ",
        "px;\n  border-start-start-radius: 1px;\n  border-start-end-radius: 1px;\n  border-end-start-radius: 0;\n  border-end-end-radius: 0;\n  margin-inline: 1px;\n  margin-block: 0;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var HISTOGRAM_BAR_MAX_HEIGHT = 40;
var loadingBlock = function() {
    return "\n  opacity: 0.5;\n  pointer: events;\n";
};
var RangeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__RangeWrapper",
    componentId: "sc-ecbca5cc-0"
})(PriceRangeHistogram_styles_templateObject(), function(props) {
    return props.isLoading && loadingBlock();
}, styles/* colors.grey4 */.O9.grey4, styles/* colors.magenta */.O9.magenta, styles/* colors.magenta */.O9.magenta, styles/* colors.magenta */.O9.magenta, styles/* colors.magenta2 */.O9.magenta2);
var InputSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__InputSection",
    componentId: "sc-ecbca5cc-1"
})(PriceRangeHistogram_styles_templateObject1(), function(props) {
    return props.isLoading && loadingBlock();
}, InputLine_styles/* InputWrapper */.SP);
var Histogram = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__Histogram",
    componentId: "sc-ecbca5cc-2"
})(PriceRangeHistogram_styles_templateObject2());
var HistogramPlaceholder = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__HistogramPlaceholder",
    componentId: "sc-ecbca5cc-3"
})(styles_templateObject3(), HISTOGRAM_BAR_MAX_HEIGHT);
var HistogramBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__HistogramBar",
    componentId: "sc-ecbca5cc-4"
})(styles_templateObject4(), styles/* colors.grey4 */.O9.grey4, function(props) {
    return props.percentage * HISTOGRAM_BAR_MAX_HEIGHT / 100;
});

// EXTERNAL MODULE: ./client/components/InputLine/index.js
var InputLine = __webpack_require__(71581);
;// CONCATENATED MODULE: ./client/components/PriceRangeHistogram/PriceRangeHistogramPlaceholder.js







var PriceRangeHistogramPlaceholder = function(param) {
    var _min = param.min, min = _min === void 0 ? 0 : _min, _max = param.max, max = _max === void 0 ? 100 : _max, _lowerBound = param.lowerBound, lowerBound = _lowerBound === void 0 ? 0 : _lowerBound, _upperBound = param.upperBound, upperBound = _upperBound === void 0 ? 100 : _upperBound;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RangeWrapper, {
                isLoading: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HistogramPlaceholder, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rc_slider_es/* default */.Z, {
                        range: true,
                        min: lowerBound,
                        max: upperBound,
                        value: [
                            min,
                            max
                        ],
                        disabled: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputSection, {
                isLoading: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLine/* default */.Z, {
                        name: "minPriceHistogram",
                        label: "Min.",
                        value: "".concat(min),
                        type: "text",
                        disabled: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLine/* default */.Z, {
                        name: "maxPriceHistogram",
                        label: "Max.",
                        value: "".concat(max),
                        type: "text",
                        disabled: true
                    })
                ]
            })
        ]
    });
};
PriceRangeHistogramPlaceholder.propTypes = {
    max: (prop_types_default()).number,
    min: (prop_types_default()).number,
    lowerBound: (prop_types_default()).number,
    upperBound: (prop_types_default()).number
};
/* harmony default export */ var PriceRangeHistogram_PriceRangeHistogramPlaceholder = (PriceRangeHistogramPlaceholder);

// EXTERNAL MODULE: ../../node_modules/react-use/esm/useMedia.js
var useMedia = __webpack_require__(6917);
// EXTERNAL MODULE: ./src/hooks/useDevice/index.ts
var useDevice = __webpack_require__(72731);
;// CONCATENATED MODULE: ./client/components/PriceRangeHistogram/utils.js
function parseDecimal(value) {
    var valueAsString = String(value);
    return parseInt(valueAsString, 10);
}

;// CONCATENATED MODULE: ./client/components/PriceRangeHistogram/index.js
















var PriceRangeHistogram = function(param) {
    var isLoading = param.isLoading, _distribution = param.distribution, distribution = _distribution === void 0 ? [] : _distribution, _max = param.max, max = _max === void 0 ? 0 : _max, _min = param.min, min = _min === void 0 ? 0 : _min, onChange = param.onChange;
    var calculateRangeDistance = function calculateRangeDistance(priceRanges) {
        return priceRanges[1].min - priceRanges[0].min;
    };
    var buildHistogramBar = function buildHistogramBar(priceRange) {
        return {
            value: priceRange.min,
            count: priceRange.count,
            valueToDisplay: "".concat(priceRange.min)
        };
    };
    var buildLastHistogramBar = function buildLastHistogramBar(priceRanges) {
        var rangeDistance = calculateRangeDistance(priceRanges);
        var lastPriceRange = (0,_object_spread/* default */.Z)({}, priceRanges[priceRanges.length - 1]);
        return {
            value: lastPriceRange.min + rangeDistance,
            count: lastPriceRange.count,
            valueToDisplay: "+".concat(lastPriceRange.min)
        };
    };
    var buildHistogram = function buildHistogram(priceRanges) {
        return (0,_to_consumable_array/* default */.Z)(priceRanges.map(function(p) {
            return buildHistogramBar(p);
        })).concat([
            buildLastHistogramBar(priceRanges)
        ]);
    };
    var getClosestHistogramItem = function getClosestHistogramItem(value) {
        return histogram.reduce(function(prev, h) {
            return Math.abs(h.value - value) < Math.abs(prev.value - value) ? h : prev;
        });
    };
    var getSelectedRange = function getSelectedRange(minValue, maxValue) {
        return histogram.filter(function(d) {
            return d.value >= minValue && d.value <= maxValue;
        });
    };
    var getRangeCount = function getRangeCount(minValue, maxValue) {
        var range = getSelectedRange(minValue, maxValue);
        return range.slice(0, range.length - 1).reduce(function(total, d) {
            return total + d.count;
        }, 0);
    };
    var isValidRange = function isValidRange(minValue, maxValue) {
        if (getRangeCount(minValue, maxValue) === 0) {
            return false;
        }
        if (minValue >= maxValue) {
            return false;
        }
        return true;
    };
    var getMaxValid = function getMaxValid(value) {
        var newMaxValue = getClosestHistogramItem(value).value;
        return isValidRange(innerMin, newMaxValue) ? newMaxValue : innerMax;
    };
    var getMinValid = function getMinValid(value) {
        var newMinValue = getClosestHistogramItem(value).value;
        return isValidRange(newMinValue, innerMax) ? newMinValue : innerMin;
    };
    var getValueToDisplayFromValue = function getValueToDisplayFromValue(value) {
        var ref;
        return (ref = histogram.find(function(h) {
            return h.value === value;
        })) === null || ref === void 0 ? void 0 : ref.valueToDisplay;
    };
    var setSlideSelectedValues = function setSlideSelectedValues(newMinValue, newMaxValue) {
        setInnerMin(newMinValue);
        setInnerMax(newMaxValue);
        setMinInputValue(getValueToDisplayFromValue(newMinValue));
        setMaxInputValue(getValueToDisplayFromValue(newMaxValue));
    };
    var executeSearch = function executeSearch(newMinValue, newMaxValue) {
        onChange(newMinValue === 0 ? null : parseDecimal(newMinValue), newMaxValue === upperBound ? null : parseDecimal(newMaxValue));
    };
    var onSlideRangeBlur = function onSlideRangeBlur(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), newMin = _param[0], newMax = _param[1];
        executeSearch(newMin, newMax);
    };
    var onInputBlur = function onInputBlur(rawMinValue, rawMaxValue) {
        var newMinValue = getMinValid(rawMinValue);
        var newMaxValue = getMaxValid(rawMaxValue);
        setSlideSelectedValues(newMinValue, newMaxValue);
        executeSearch(newMinValue, newMaxValue);
    };
    var onRangeMove = function onRangeMove(newMin, newMax) {
        setSlideSelectedValues(getMinValid(newMin), getMaxValid(newMax));
    };
    var shouldDisplayPlaceholder = function shouldDisplayPlaceholder() {
        return isLoading || lowerBound === 0 && upperBound === 0 || histogram.length < 2;
    };
    var ref = (0,react.useState)(min), innerMin = ref[0], setInnerMin = ref[1];
    var ref1 = (0,react.useState)(max), innerMax = ref1[0], setInnerMax = ref1[1];
    var ref2 = (0,react.useState)([]), histogram = ref2[0], setHistogram = ref2[1];
    var ref3 = (0,react.useState)(0), lowerBound = ref3[0], setLowerBound = ref3[1];
    var ref4 = (0,react.useState)(0), upperBound = ref4[0], setUpperBound = ref4[1];
    var ref5 = (0,react.useState)(0), maxDistributionCount = ref5[0], setMaxDistributionCount = ref5[1];
    var ref6 = (0,react.useState)(0), minInputValue = ref6[0], setMinInputValue = ref6[1];
    var ref7 = (0,react.useState)(0), maxInputValue = ref7[0], setMaxInputValue = ref7[1];
    var device = (0,useDevice/* useDevice */.F)().device;
    var isWide = (0,useMedia/* default */.Z)(styles/* breakpoint.tablet */.eq.tablet, device === "desktop") && device !== "tablet";
    (0,react.useEffect)(function() {
        if (distribution.length < 2) {
            return;
        }
        var priceHistogram = buildHistogram(distribution);
        setHistogram(priceHistogram);
        setLowerBound(priceHistogram[0].value);
        setUpperBound(priceHistogram[priceHistogram.length - 1].value);
        setMaxDistributionCount(priceHistogram.reduce(function(maxCount, current) {
            return maxCount < current.count ? current.count : maxCount;
        }, 0));
    }, [
        distribution
    ]) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    (0,react.useEffect)(function() {
        if (histogram.length < 2) {
            return;
        }
        var newMin = getClosestHistogramItem(min || lowerBound);
        var newMax = getClosestHistogramItem(max || upperBound);
        setInnerMin(newMin.value);
        setInnerMax(newMax.value);
        setMinInputValue(newMin.valueToDisplay);
        setMaxInputValue(newMax.valueToDisplay);
    }, [
        histogram,
        min,
        max
    ]) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    if (shouldDisplayPlaceholder()) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceRangeHistogram_PriceRangeHistogramPlaceholder, {
            min: min,
            max: max || upperBound,
            lowerBound: lowerBound,
            upperBound: upperBound
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RangeWrapper, {
                isLoading: isLoading,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Histogram, {
                        children: histogram.slice(0, histogram.length - 1).map(function(bar) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HistogramBar, {
                                percentage: bar.count * 100 / maxDistributionCount
                            }, bar.value);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(rc_slider_es/* default */.Z, {
                        range: true,
                        min: lowerBound,
                        max: upperBound,
                        allowCross: false,
                        value: [
                            innerMin,
                            innerMax
                        ],
                        disabled: isLoading,
                        onChangeComplete: onSlideRangeBlur,
                        reverse: (0,rtl/* isRTL */.dZ)(),
                        onChange: function(r) {
                            return onRangeMove(r[0], r[1]);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputSection, {
                isLoading: isLoading,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLine/* default */.Z, {
                        label: "Min.",
                        value: "".concat(minInputValue),
                        type: isWide ? "text" : "number",
                        inputmode: "numeric",
                        pattern: "[0-9]*",
                        name: "minPrice",
                        onChange: function(e) {
                            return setMinInputValue(e.target.value);
                        },
                        onBlur: function(e) {
                            return onInputBlur(e.target.value, innerMax);
                        },
                        disabled: isLoading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLine/* default */.Z, {
                        label: "Max.",
                        value: isWide ? "".concat(maxInputValue) : "".concat(maxInputValue).replace(/\+/g, ""),
                        type: isWide ? "text" : "number",
                        inputmode: "numeric",
                        pattern: "[0-9]*",
                        name: "maxPrice",
                        onChange: function(e) {
                            return setMaxInputValue(e.target.value.replace(/\+/g, ""));
                        },
                        onBlur: function(e) {
                            return onInputBlur(innerMin, e.target.value);
                        },
                        disabled: isLoading
                    })
                ]
            })
        ]
    });
};
PriceRangeHistogram.propTypes = {
    isLoading: (prop_types_default()).bool,
    distribution: prop_types_default().arrayOf(prop_types_default().shape({
        min: (prop_types_default()).number,
        count: (prop_types_default()).number
    })),
    max: (prop_types_default()).number,
    min: (prop_types_default()).number,
    onChange: (prop_types_default()).func.isRequired
};
/* harmony default export */ var components_PriceRangeHistogram = (PriceRangeHistogram);

// EXTERNAL MODULE: ./client/components/FilterPrices/styles.module.css
var styles_module = __webpack_require__(30074);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./client/components/FilterPrices/index.tsx













var FilterPrices = function() {
    var onRangeChange = function onRangeChange(minPrice, maxPrice) {
        setFilters((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters), {
            minPrice: minPrice,
            maxPrice: maxPrice
        }));
    };
    var intl = (0,useIntl/* default */.Z)();
    var distributionPriceRange = (0,es/* useSelector */.v9)(selectors/* getDistributionPriceRange */.SR);
    var isFetching = (0,es/* useSelector */.v9)(selectors/* getIsFetching */.ab);
    var ref = (0,useMarket/* useMarket */.A)(), currency = ref.currency, market = ref.market;
    var ref1 = (0,react.useContext)(context/* FiltersContext */.o), filters = ref1.filters, setFilters = ref1.setFilters;
    var ref2 = (0,usePrices/* usePrices */.h)({
        rooms: []
    }), appPriceType = ref2.priceType;
    var domainPriceType = (0,react.useMemo)(function() {
        return PriceType/* PriceType.createOrUndefinedFromCookie */.FT.createOrUndefinedFromCookie({
            value: appPriceType
        });
    }, [
        appPriceType
    ]);
    var currencySymbol = (0,react.useMemo)(function() {
        var symbol = intl.formatNumber(0, {
            style: "currency",
            currency: currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).replace(/\d/g, "").trim();
        if (market === "au") {
            return symbol.replace(/(A|AU)?\$/, "AU$");
        }
        if (market === "ca") {
            return symbol.replace(/(CA)?\$/, "CA$");
        }
        if (market === "no") {
            return symbol.replace(/kr/, currency);
        }
        return symbol;
    }, [
        currency,
        market,
        intl
    ]);
    var min = filters.minPrice ? +filters.minPrice : undefined;
    var max = filters.maxPrice ? +filters.maxPrice : undefined;
    var titleMessageKey = (domainPriceType === null || domainPriceType === void 0 ? void 0 : domainPriceType.isFeaturedPriceTotal()) ? "global.total-price" : "global.price-per-night";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).filterPricesBase,
        "data-testid": "filter-price",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                className: (styles_module_default()).title,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: titleMessageKey
                    }),
                    " (".concat(currencySymbol, ")")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PriceRangeHistogram, {
                isLoading: isFetching,
                min: min,
                max: max,
                distribution: distributionPriceRange,
                onChange: onRangeChange
            })
        ]
    });
};
/* harmony default export */ var components_FilterPrices = (FilterPrices);

;// CONCATENATED MODULE: ./client/components/FilterRatings/styles.js

function FilterRatings_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-block: 15px;\n  padding-inline: 20px;\n"
    ]);
    FilterRatings_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FilterRatings_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: 700;\n  margin-block-end: 1rem;\n"
    ]);
    FilterRatings_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FilterRatings_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  > li {\n    margin-block: 0 5px;\n    margin-inline: 0;\n    font-size: 16px;\n    label {\n      text-transform: capitalize;\n    }\n  }\n"
    ]);
    FilterRatings_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var FilterRatingsBase = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "styles__FilterRatingsBase",
    componentId: "sc-dec053b2-0"
})(FilterRatings_styles_templateObject());
var FilterRatings_styles_Title = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    displayName: "styles__Title",
    componentId: "sc-dec053b2-1"
})(FilterRatings_styles_templateObject1(), styles/* colors.grey1 */.O9.grey1);
var FilterRatings_styles_List = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "styles__List",
    componentId: "sc-dec053b2-2"
})(FilterRatings_styles_templateObject2());

;// CONCATENATED MODULE: ./client/components/FilterRatings/index.tsx









var availableRatings = [
    "9",
    "8",
    "7",
    "6"
];
var FilterRatings = function() {
    var handleClick = function handleClick(rating) {
        var index = selected.indexOf(rating);
        var ratingExists = index > -1;
        var filteredRatings = ratingExists ? selected.filter(function(f, i) {
            return i !== index;
        }) : (0,_to_consumable_array/* default */.Z)(selected).concat([
            rating
        ]);
        setFilters((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters), {
            ratings: filteredRatings
        }));
    };
    var i18n = (0,src/* useS4LContext */.ms)().i18n;
    var ref = (0,react.useContext)(context/* FiltersContext */.o), filters = ref.filters, setFilters = ref.setFilters;
    var ref1 = (0,react.useState)([]), selected = ref1[0], setSelected = ref1[1];
    (0,react.useEffect)(function() {
        setSelected(filters.ratings || []);
    }, [
        filters.ratings
    ]);
    var rattingMessages = {
        9: i18n.formatMessage({
            id: "score.range-1"
        }),
        8: i18n.formatMessage({
            id: "score.range-2"
        }),
        7: i18n.formatMessage({
            id: "score.range-3"
        }),
        6: i18n.formatMessage({
            id: "score.range-4"
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterRatingsBase, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRatings_styles_Title, {
                children: i18n.formatMessage({
                    id: "global.guest-rating"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterRatings_styles_List, {
                children: availableRatings.map(function(rating) {
                    var isSelected = !!selected.find(function(r) {
                        return r === rating;
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    rattingMessages[rating],
                                    ": ".concat(rating, "+")
                                ]
                            }),
                            name: "rating-".concat(rating),
                            onChange: function() {
                                return handleClick(rating);
                            },
                            selected: isSelected
                        })
                    }, "rating-".concat(rating));
                })
            })
        ]
    });
};
/* harmony default export */ var components_FilterRatings = (FilterRatings);

// EXTERNAL MODULE: ./client/components/FilterThemes/styles.module.css
var FilterThemes_styles_module = __webpack_require__(93610);
var FilterThemes_styles_module_default = /*#__PURE__*/__webpack_require__.n(FilterThemes_styles_module);
// EXTERNAL MODULE: ../../packages/ds/src/index.ts + 105 modules
var ds_src = __webpack_require__(55349);
// EXTERNAL MODULE: ./client/components/FilterThemes/constants.ts
var FilterThemes_constants = __webpack_require__(43466);
;// CONCATENATED MODULE: ./client/components/FilterThemes/index.tsx











var FilterThemes = function() {
    var handleClick = function handleClick(theme) {
        var index = selected.indexOf(theme);
        var themeExists = index > -1;
        var filteredThemes = themeExists ? selected.filter(function(f, i) {
            return i !== index;
        }) : (0,_to_consumable_array/* default */.Z)(selected).concat([
            theme
        ]);
        setFilters((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filters), {
            themes: filteredThemes
        }));
    };
    var ref = (0,react.useContext)(context/* FiltersContext */.o), filters = ref.filters, setFilters = ref.setFilters;
    var i18n = (0,src/* useS4LContext */.ms)().i18n;
    var ref1 = (0,react.useState)([]), selected = ref1[0], setSelected = ref1[1];
    (0,react.useEffect)(function() {
        setSelected(filters.themes || []);
    }, [
        filters.themes
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (FilterThemes_styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                as: "h3",
                size: "l",
                bold: true,
                className: "mb-16",
                children: i18n.formatMessage({
                    id: "filter-category.trip-type"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (FilterThemes_styles_module_default()).list,
                children: FilterThemes_constants/* THEMES.map */.y.map(function(theme) {
                    var isSelected = !!selected.find(function(f) {
                        return f === theme.slug;
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (FilterThemes_styles_module_default()).listItem,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(ds_src/* Typography */.ZT, {
                                size: "l",
                                children: i18n.formatMessage({
                                    id: theme.name
                                })
                            }),
                            name: "theme-".concat(theme.slug),
                            onChange: function() {
                                return handleClick(theme.slug);
                            },
                            selected: isSelected
                        })
                    }, theme.slug);
                })
            })
        ]
    });
};
/* harmony default export */ var components_FilterThemes = (FilterThemes);

// EXTERNAL MODULE: ../../packages/uikit/src/index.ts + 74 modules
var uikit_src = __webpack_require__(61756);
// EXTERNAL MODULE: ../../packages/stayforlong/src/property/domain/SearchFilters.ts + 2 modules
var SearchFilters = __webpack_require__(377);
// EXTERNAL MODULE: ../../packages/stayforlong/src/property/domain/ListOfPriceDistribution.ts
var ListOfPriceDistribution = __webpack_require__(80762);
;// CONCATENATED MODULE: ./client/components/FiltersForm/index.tsx
















var Filters = function() {
    var handleApplyFilters = function handleApplyFilters(newFilters) {
        setFilters(function(prev) {
            return (0,_object_spread/* default */.Z)({}, prev, newFilters);
        });
    };
    var ref, ref1;
    var query = (0,router.useRouter)().query;
    var distributionPriceRange = (0,es/* useSelector */.v9)(selectors/* getDistributionPriceRange */.SR);
    var hasNewFilters = (ref = query.ff) === null || ref === void 0 ? void 0 : ref.includes("new_filters");
    var hasMealPlans = (ref1 = query.ff) === null || ref1 === void 0 ? void 0 : ref1.includes("meal_plans");
    var ref2 = (0,react.useContext)(context/* FiltersContext */.o), filters = ref2.filters, setFilters = ref2.setFilters;
    var filtersModel = SearchFilters/* SearchFilters.fromLegacyContext */.J.fromLegacyContext(filters);
    var listOfPriceDistributionModel = ListOfPriceDistribution/* ListOfPriceDistribution.fromLegacyContext */.z.fromLegacyContext(distributionPriceRange);
    if (hasNewFilters) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(uikit_src/* SearchFilters */.JB, {
            OnFilterChange: handleApplyFilters,
            defaultFiltersJSON: filtersModel.toJSON(),
            listOfPriceDistributionJSON: listOfPriceDistributionModel.toJSON(),
            showMealPlans: hasMealPlans
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FilterPrices, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FilterCategory, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FilterRatings, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FilterThemes, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FilterAccommodationTypes, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FilterFacilities, {})
        ]
    });
};
/* harmony default export */ var FiltersForm = (Filters);


/***/ }),

/***/ 71581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52342);




var InputLine = function(param) {
    var ariaAutocomplete = param.ariaAutocomplete, ariaExpanded = param.ariaExpanded, autoComplete = param.autoComplete, className = param.className, checked = param.checked, disabled = param.disabled, error = param.error, _formBackground = param.formBackground, formBackground = _formBackground === void 0 ? "white" : _formBackground, id = param.id, inputRef = param.inputRef, isFocused = param.isFocused, label = param.label, last = param.last, name = param.name, onBlur = param.onBlur, onChange = param.onChange, onFocus = param.onFocus, onKeyDown = param.onKeyDown, placeholder = param.placeholder, readOnly = param.readOnly, role = param.role, type = param.type, value = param.value, icon = param.icon, inputmode = param.inputmode, pattern = param.pattern;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(inputRef);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), hasFocus = ref1[0], setFocus = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), ssrDone = ref2[0], setSsrDone = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref1, ref2;
        setSsrDone(true);
        if (document.hasFocus() && (ref === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.contains) === null || ref2 === void 0 ? void 0 : ref2.call(ref1, document.activeElement))) {
            setFocus(true);
        }
    }, []);
    if (type === "radio") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .InputRadioWrapper */ .kA, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .LabelRadio */ .A$, {
                htmlFor: id,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .InputRadio */ .rW, {
                        "aria-autocomplete": ariaAutocomplete,
                        "aria-expanded": ariaExpanded,
                        autoComplete: autoComplete,
                        "data-testid": id,
                        disabled: disabled,
                        id: id,
                        name: name,
                        onBlur: onBlur,
                        onChange: onChange,
                        onFocus: onFocus,
                        onKeyDown: onKeyDown,
                        placeholder: placeholder,
                        readOnly: readOnly,
                        ref: ref,
                        role: role,
                        type: type,
                        value: value,
                        checked: checked
                    }),
                    label
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .InputWrapper */ .SP, {
        isFocused: isFocused || hasFocus,
        className: className,
        error: error,
        last: last,
        background: formBackground,
        disabled: disabled,
        children: [
            icon,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Label */ .__, {
                htmlFor: id,
                withIcon: !!icon,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .InputElement */ .kO, {
                        "aria-autocomplete": ariaAutocomplete,
                        "aria-expanded": ariaExpanded,
                        autoComplete: autoComplete,
                        "data-testid": id,
                        disabled: disabled,
                        id: id,
                        name: name,
                        onChange: onChange,
                        onBlur: function(event) {
                            setFocus(false);
                            return onBlur && onBlur(event);
                        },
                        onFocus: function(event) {
                            setFocus(true);
                            return onFocus && onFocus(event);
                        },
                        onKeyDown: onKeyDown,
                        placeholder: placeholder,
                        readOnly: readOnly,
                        ref: ref,
                        role: role,
                        type: type,
                        inputmode: inputmode,
                        pattern: pattern,
                        value: value
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_2__/* .LabelText */ .NV, {
                        withIcon: !!icon,
                        isTransitioned: (isFocused || hasFocus || value) && ssrDone,
                        background: disabled || !value ? "transparent" : formBackground,
                        children: label
                    })
                ]
            })
        ]
    });
};
InputLine.propTypes = {
    ariaAutocomplete: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    ariaExpanded: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    autoComplete: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    checked: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    disabled: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
    error: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
    formBackground: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOf([
        "white",
        "grey7"
    ]),
    icon: prop_types__WEBPACK_IMPORTED_MODULE_3___default().instanceOf(Object),
    id: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    inputRef: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
    isFocused: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
    label: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node),
    last: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
    name: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string.isRequired),
    onBlur: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
    onChange: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
    onFocus: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
    onKeyDown: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func),
    placeholder: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    readOnly: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool),
    role: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    type: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOf([
        "text",
        "number",
        "search",
        "email",
        "tel",
        "checkbox",
        "labeled",
        "password",
        "radio", 
    ]).isRequired,
    value: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number)
    ]),
    inputmode: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    pattern: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (InputLine);


/***/ }),

/***/ 52342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A$": function() { return /* binding */ LabelRadio; },
/* harmony export */   "NV": function() { return /* binding */ LabelText; },
/* harmony export */   "SP": function() { return /* binding */ InputWrapper; },
/* harmony export */   "__": function() { return /* binding */ Label; },
/* harmony export */   "iH": function() { return /* binding */ autofillStyles; },
/* harmony export */   "kA": function() { return /* binding */ InputRadioWrapper; },
/* harmony export */   "kO": function() { return /* binding */ InputElement; },
/* harmony export */   "rW": function() { return /* binding */ InputRadio; },
/* harmony export */   "zy": function() { return /* binding */ getInputBorderColor; }
/* harmony export */ });
/* unused harmony export getInputBackgroundColor */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12411);
/* eslint-disable no-nested-ternary */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  input:-webkit-autofill:active {\n    box-shadow: 0 0 0 30px transparent inset;\n    transition: background-color 5000s ease-in-out 0s;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n\n  border: 2px solid ",
        ";\n  border-radius: 8px;\n  position: relative;\n  background-color: ",
        ";\n\n  &:hover {\n    border: 2px solid ",
        ";\n  }\n\n  svg {\n    margin-block: 10px;\n    margin-inline: 8px 14px;\n    fill: ",
        ";\n    flex: 0 0 auto;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  transform: translate(calc(var(--transform-direction) * -60px), -35px) scale(0.75);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  transform: translate(calc(var(--transform-direction) * -14px), -35px) scale(0.75);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: transparent;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  white-space: nowrap;\n  position: absolute;\n  inset-block-start: 50%;\n  inset-inline-start: 10px;\n  transform: translateY(-50%);\n  padding-block: 3px;\n  padding-inline: 5px;\n  background-color: ",
        ";\n  transition:\n    transform 0.1s,\n    background-color 0.1s;\n\n  ",
        "\n\n  background-color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  font-family: ",
        ";\n  width: 100%;\n  position: relative;\n  color: ",
        ";\n\n  &:focus-within ",
        " {\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-block: 12px;\n  padding-inline: 14px;\n  width: 100%;\n  font-weight: 700;\n  border: none;\n  border-radius: 8px;\n\n  &:focus {\n    outline: none;\n  }\n\n  &:disabled {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  color: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  box-sizing: content-box;\n  position: relative;\n  appearance: none;\n  outline: none;\n  background-color: transparent;\n  width: 21px;\n  height: 21px;\n  padding-block: 0;\n  padding-inline: 0;\n  margin-block: 0;\n  margin-inline: 0 12px;\n  border-radius: 100%;\n  background-color: ",
        ";\n  flex: 0 0 auto;\n\n  &:checked {\n    background-color: ",
        ";\n    &::after {\n      background-color: ",
        ";\n    }\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    width: 9px;\n    height: 9px;\n    background-color: ",
        ";\n    border: 4px solid ",
        ";\n    border-radius: 100%;\n    inset-inline-start: 2px;\n    inset-block-start: 2px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

var getInputBorderColor = function(props) {
    if (props.isFocused) {
        return props.theme.colors.grey3;
    }
    if (props.error) {
        return props.theme.colors.failure;
    }
    return props.theme.colors.grey5;
};
var autofillStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject());
var getInputBackgroundColor = function(props) {
    if (props.disabled) {
        return props.theme.colors.grey5;
    }
    if (props.error) {
        return "var(--color--semantic--error--50)";
    }
    return "";
};
var InputWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__InputWrapper",
    componentId: "sc-6b552b77-0"
})(_templateObject1(), function(props) {
    return getInputBorderColor(props);
}, function(props) {
    return getInputBackgroundColor(props);
}, function(props) {
    return props.theme.colors.grey3;
}, function(props) {
    return props.theme.colors.grey3;
});
var labelWithiconTransitioned = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject2());
var labelTransitioned = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject3());
var getLabelBackgroundColor = function(props) {
    if (props.isTransitioned) {
        return !props.withIcon ? labelTransitioned : labelWithiconTransitioned;
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject4());
};
var LabelText = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__LabelText",
    componentId: "sc-6b552b77-1"
})(_templateObject5(), function(props) {
    return props.theme.colors[props.background];
}, function(props) {
    return getLabelBackgroundColor(props);
}, function(props) {
    return props.theme.colors.grey8;
});
var Label = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    displayName: "styles__Label",
    componentId: "sc-6b552b77-2"
})(_templateObject6(), function(props) {
    return props.theme.fonts.families.primary;
}, function(props) {
    return props.theme.colors.grey3;
}, LabelText, function(props) {
    return !props.withIcon ? labelTransitioned : labelWithiconTransitioned;
}, autofillStyles);
var InputElement = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    displayName: "styles__InputElement",
    componentId: "sc-6b552b77-3"
})(_templateObject7(), function(props) {
    return props.theme.colors.grey5;
}, function(props) {
    return props.theme.colors.grey3;
});
var InputRadioWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "styles__InputRadioWrapper",
    componentId: "sc-6b552b77-4"
})(_templateObject8());
var LabelRadio = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    displayName: "styles__LabelRadio",
    componentId: "sc-6b552b77-5"
})(_templateObject9(), function(props) {
    return props.theme.colors.grey3;
});
var InputRadio = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    displayName: "styles__InputRadio",
    componentId: "sc-6b552b77-6"
})(_templateObject10(), function(props) {
    return props.theme.colors.grey5;
}, function(props) {
    return props.theme.colors.brand1;
}, function(props) {
    return props.theme.colors.brand1;
}, function(props) {
    return props.theme.colors.grey8;
}, function(props) {
    return props.theme.colors.grey8;
});


/***/ }),

/***/ 47012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5834 5.1879C20.032 5.51011 20.1344 6.13494 19.8122 6.58349L11.1922 18.5835C11.013 18.8329 10.7292 18.9862 10.4223 18.9992C10.1155 19.0122 9.8197 18.8835 9.62008 18.6501L4.24008 12.3601C3.8811 11.9404 3.93032 11.3091 4.35002 10.9501C4.76973 10.5912 5.40097 10.6404 5.75996 11.0601L10.3115 16.3815L18.1878 5.41666C18.5101 4.96811 19.1349 4.86569 19.5834 5.1879Z"
}), "Done"));


/***/ }),

/***/ 61706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var client_icons_Done__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47012);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54697);





var Checkbox = function(param) {
    var className = param.className, error = param.error, _isFocused = param.isFocused, isFocused = _isFocused === void 0 ? false : _isFocused, label = param.label, link = param.link, name = param.name, onChange = param.onChange, onFocus = param.onFocus, _required = param.required, required = _required === void 0 ? false : _required, selected = param.selected, _type = param.type, type = _type === void 0 ? "checkbox" : _type, dataTestId = param.dataTestId;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .CheckboxBase */ .A, {
        htmlFor: name,
        isChecked: selected,
        isFocused: isFocused,
        error: error,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                "data-testid": dataTestId,
                role: "checkbox",
                "aria-checked": selected,
                checked: selected,
                id: name,
                name: name,
                onChange: function() {
                    return onChange({
                        name: name
                    });
                },
                onFocus: onFocus,
                type: type
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(client_icons_Done__WEBPACK_IMPORTED_MODULE_2__["default"], {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                className: className,
                asterisk: required,
                children: link || label
            })
        ]
    });
};
Checkbox.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    error: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    isFocused: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    label: prop_types__WEBPACK_IMPORTED_MODULE_4___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_4___default().element)
    ]),
    link: prop_types__WEBPACK_IMPORTED_MODULE_4___default().instanceOf(Object),
    name: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string.isRequired),
    onChange: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func.isRequired),
    onFocus: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
    required: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool),
    selected: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().bool.isRequired),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    dataTestId: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Checkbox);


/***/ }),

/***/ 54697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ CheckboxBase; },
/* harmony export */   "x": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12411);
/* harmony import */ var client_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89804);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  margin-block-end: 0.8em;\n  user-select: none;\n\n  > svg {\n    border-radius: 3px;\n    border: 2px solid;\n    flex: 0 0 auto;\n    height: 20px;\n    vertical-align: bottom;\n    width: 20px;\n\n    ",
        "\n  }\n\n  ",
        "\n\n  input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      :after {\n        content: '*';\n        color: ",
        ";\n        margin-inline-start: 5px;\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  display: inline-block;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.7em;\n  margin-inline-start: 14px;\n  vertical-align: middle;\n\n  a,\n  a:active {\n    color: ",
        ";\n    text-decoration: none;\n    text-transform: lowercase;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var CheckboxBase = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    displayName: "styles__CheckboxBase",
    componentId: "sc-273adab7-0"
})(_templateObject(), function(props) {
    return props.isChecked ? "\n            background-color: ".concat(client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.magenta */ .O9.magenta, ";\n            border-color: ").concat(client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.magenta */ .O9.magenta, ";\n            fill: ").concat(client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.white */ .O9.white, ";\n          ") : "\n            background-color: ".concat(client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.white */ .O9.white, ";\n            border-color: ").concat(client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey4 */ .O9.grey4, ";\n            fill: ").concat(client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.white */ .O9.white, ";\n          ");
}, function(props) {
    return props.isFocused && "svg { border-color: ".concat(client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey2 */ .O9.grey2, "; }");
});
var Text = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "styles__Text",
    componentId: "sc-273adab7-1"
})(_templateObject2(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.grey2 */ .O9.grey2, client_styles__WEBPACK_IMPORTED_MODULE_1__/* .fonts["default"] */ .Rq["default"], function(props) {
    return props.size ? "".concat(props.size, "px") : "16px";
}, client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.blue */ .O9.blue, function(props) {
    return props.asterisk && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), client_styles__WEBPACK_IMPORTED_MODULE_1__/* .colors.magenta */ .O9.magenta);
});


/***/ }),

/***/ 82598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SR": function() { return /* binding */ getDistributionPriceRange; },
/* harmony export */   "ab": function() { return /* binding */ getIsFetching; },
/* harmony export */   "gp": function() { return /* binding */ getPropertiesApiParams; },
/* harmony export */   "sA": function() { return /* binding */ getCount; },
/* harmony export */   "vw": function() { return /* binding */ getProperties; }
/* harmony export */ });
/* unused harmony export getPropertiesAndHighlighted */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26297);
/* harmony import */ var reselect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5994);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84785);
/* harmony import */ var src_comps_Page_selectors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91601);
/* harmony import */ var client_contexts_Property_selectors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54027);
/* harmony import */ var src_effects_Search_selectors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22671);
/* harmony import */ var src_effects_Properties_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30249);








var getCount = function(state) {
    var ref;
    return (ref = state[_constants__WEBPACK_IMPORTED_MODULE_2__/* .PROPERTIES_STATE */ ._9]) === null || ref === void 0 ? void 0 : ref.count;
};
var getDistributionPriceRange = function(state) {
    var ref;
    return (ref = state[_constants__WEBPACK_IMPORTED_MODULE_2__/* .PROPERTIES_STATE */ ._9]) === null || ref === void 0 ? void 0 : ref.distribution;
};
var getIsFetching = function(state) {
    var ref;
    return (ref = state[_constants__WEBPACK_IMPORTED_MODULE_2__/* .PROPERTIES_STATE */ ._9]) === null || ref === void 0 ? void 0 : ref.isFetching;
};
var getProperties = function(state) {
    var ref;
    return (ref = state[_constants__WEBPACK_IMPORTED_MODULE_2__/* .PROPERTIES_STATE */ ._9]) === null || ref === void 0 ? void 0 : ref.properties;
};
var getPropertiesApiParams = (0,reselect__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)([
    src_effects_Search_selectors__WEBPACK_IMPORTED_MODULE_1__/* .getSearch */ .on,
    src_comps_Page_selectors__WEBPACK_IMPORTED_MODULE_0__/* .getLanguage */ .G3
], function(_param, language) {
    var children = _param.children, checkIn = _param.checkIn, checkOut = _param.checkOut, otherSearchParams = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "checkIn",
        "checkOut"
    ]);
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        checkIn: checkIn,
        checkOut: checkOut,
        children: children,
        language: language
    }, otherSearchParams);
});
var getPropertiesAndHighlighted = (0,reselect__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)([
    getProperties,
    client_contexts_Property_selectors__WEBPACK_IMPORTED_MODULE_6__/* .getProperty */ .$
], function(properties, property) {
    return (0,src_effects_Properties_utils__WEBPACK_IMPORTED_MODULE_7__/* .upHighlighted */ .R)({
        properties: properties,
        property: property
    });
});


/***/ }),

/***/ 30074:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"filterPricesBase":"styles_filterPricesBase__8Z6_Z","title":"styles_title__MtCrk"};

/***/ }),

/***/ 93610:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__P_yBB","list":"styles_list__IG5Sk","listItem":"styles_listItem__i7UjS"};

/***/ })

}]);